import { render, staticRenderFns } from "./DatosSimpatizanteSgaComponent.vue?vue&type=template&id=218f41be"
import script from "./DatosSimpatizanteSgaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosSimpatizanteSgaComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports